<template>
  <div class="py-6 px-4">
    <h2 class="text-xl font-semibold text-gray-800 mb-6">
      {{ couponData?.mode === 'edit' ? 'Modifier le Coupon' : 'Nouveau Coupon' }}
    </h2>
{{couponData}}
    <form @submit.prevent ref="form" class="space-y-6">
      <!-- Code et Titre -->
      <div class="rounded-2xl border border-gray-200 bg-white p-6 space-y-4">
        <h3 class="text-sm font-semibold text-gray-700 uppercase tracking-wide">
          Informations générales
        </h3>

        <div class="grid grid-cols-1 gap-4">
          <div>
            <label class="mb-1.5 block text-sm font-medium text-gray-700">
              Code du coupon *
            </label>
            <input
              required
              type="text"
              v-model="coupon.code"
              class="w-full rounded-lg border border-gray-300 px-4 py-3 text-sm text-gray-800 shadow-theme-xs focus:border-primary-500 focus:outline-hidden focus:ring-3 focus:ring-primary-500/10"
              placeholder="Ex: WELCOME15"
            />
          </div>

          <!-- <div>
            <label class="mb-1.5 block text-sm font-medium text-gray-700">
              Titre *
            </label>
            <input
              required
              type="text"
              v-model="coupon.title"
              class="w-full rounded-lg border border-gray-300 px-4 py-3 text-sm text-gray-800 shadow-theme-xs focus:border-primary-500 focus:outline-hidden focus:ring-3 focus:ring-primary-500/10"
              placeholder="Ex: Réduction de bienvenue"
            />
          </div> -->

          <div>
            <label class="mb-1.5 block text-sm font-medium text-gray-700">
              Description
            </label>
            <textarea
              v-model="coupon.description"
              rows="3"
              class="w-full rounded-lg border border-gray-300 px-4 py-3 text-sm text-gray-800 shadow-theme-xs focus:border-primary-500 focus:outline-hidden focus:ring-3 focus:ring-primary-500/10"
              placeholder="Décrivez les conditions d'utilisation..."
            ></textarea>
          </div>
        </div>
      </div>

      <!-- Réduction -->
      <div class="rounded-2xl border border-gray-200 bg-white p-6 space-y-4">
        <h3 class="text-sm font-semibold text-gray-700 uppercase tracking-wide">
          Réduction
        </h3>

        <div class="grid grid-cols-1 sm:grid-cols-2 gap-4">
          <div>
            <label class="mb-1.5 block text-sm font-medium text-gray-700">
              Type de réduction *
            </label>
            <select
              required
              v-model="coupon.type"
              class="w-full rounded-lg border border-gray-300 px-4 py-3 text-sm text-gray-800 shadow-theme-xs focus:border-primary-500 focus:outline-hidden focus:ring-3 focus:ring-primary-500/10"
            >
              <option value="percentage">Pourcentage (%)</option>
              <option value="fixed">Montant fixe (FCFA)</option>
            </select>
          </div>

          <div>
            <label class="mb-1.5 block text-sm font-medium text-gray-700">
              {{ coupon.type === 'percentage' ? 'Pourcentage' : 'Montant' }} *
            </label>
            <input
              required
              type="number"
              :min="coupon.type === 'percentage' ? 1 : 0"
              :max="coupon.type === 'percentage' ? 100 : null"
              v-model.number="coupon.discount"
              class="w-full rounded-lg border border-gray-300 px-4 py-3 text-sm text-gray-800 shadow-theme-xs focus:border-primary-500 focus:outline-hidden focus:ring-3 focus:ring-primary-500/10"
              :placeholder="coupon.type === 'percentage' ? 'Ex: 15' : 'Ex: 1000'"
            />
          </div>
        </div>

        <div class="flex items-center gap-2">
          <input
            type="checkbox"
            id="merchandSupport"
            v-model="coupon.merchandSupportDiscount"
            class="w-4 h-4 rounded border-gray-300 text-primary focus:ring-primary"
          />
          <label for="merchandSupport" class="text-sm text-gray-700">
            Le merchant supporte la réduction
          </label>
        </div>
      </div>

      <!-- Dates -->
      <div class="rounded-2xl border border-gray-200 bg-white p-6 space-y-4">
        <h3 class="text-sm font-semibold text-gray-700 uppercase tracking-wide">
          Validité
        </h3>

        <div class="grid grid-cols-1 sm:grid-cols-2 gap-4">
          <div>
            <label class="mb-1.5 block text-sm font-medium text-gray-700">
              Date de début *
            </label>
            <input
              required
              type="datetime-local"
              v-model="startDateLocal"
              class="w-full rounded-lg border border-gray-300 px-4 py-3 text-sm text-gray-800 shadow-theme-xs focus:border-primary-500 focus:outline-hidden focus:ring-3 focus:ring-primary-500/10"
            />
          </div>

          <div>
            <label class="mb-1.5 block text-sm font-medium text-gray-700">
              Date de fin *
            </label>
            <input
              required
              type="datetime-local"
              v-model="endDateLocal"
              class="w-full rounded-lg border border-gray-300 px-4 py-3 text-sm text-gray-800 shadow-theme-xs focus:border-primary-500 focus:outline-hidden focus:ring-3 focus:ring-primary-500/10"
            />
          </div>
        </div>
      </div>

      <!-- Restaurant -->
      <div class="rounded-2xl border border-gray-200 bg-white p-6 space-y-4">
        <h3 class="text-sm font-semibold text-gray-700 uppercase tracking-wide">
          Attribution
        </h3>

        <div>
          <label class="mb-1.5 block text-sm font-medium text-gray-700">
            Restaurant *
          </label>
          <select
            required
            v-model="coupon.storeId"
            class="w-full rounded-lg border border-gray-300 px-4 py-3 text-sm text-gray-800 shadow-theme-xs focus:border-primary-500 focus:outline-hidden focus:ring-3 focus:ring-primary-500/10"
          >
            <option value="all">Tous les restaurants</option>
            <option v-for="restaurant in restaurants" :key="restaurant.id" :value="restaurant.id">
              {{ restaurant.storeName || restaurant.name }}
            </option>
          </select>
          <p class="mt-1 text-xs text-gray-500">
            Sélectionnez "Tous les restaurants" pour un coupon valide partout
          </p>
        </div>

        <div>
          <label class="mb-1.5 block text-sm font-medium text-gray-700">
            Nombre d'utilisations maximum (Global) *
          </label>
          <input
            required
            type="number"
            min="1"
            v-model.number="coupon.nbAppliance"
            class="w-full rounded-lg border border-gray-300 px-4 py-3 text-sm text-gray-800 shadow-theme-xs focus:border-primary-500 focus:outline-hidden focus:ring-3 focus:ring-primary-500/10"
            placeholder="Ex: 100"
          />
        </div>

        <div>
          <label class="mb-1.5 block text-sm font-medium text-gray-700">
            Nombre d'utilisations par utilisateur *
          </label>
          <input
            required
            type="number"
            min="1"
            v-model.number="coupon.userLimit"
            class="w-full rounded-lg border border-gray-300 px-4 py-3 text-sm text-gray-800 shadow-theme-xs focus:border-primary-500 focus:outline-hidden focus:ring-3 focus:ring-primary-500/10"
            placeholder="Ex: 1"
          />
        </div>

        <div class="flex items-center gap-2 pt-2">
          <input
            type="checkbox"
            id="isVisible"
            v-model="coupon.isVisible"
            class="w-4 h-4 rounded border-gray-300 text-primary focus:ring-primary"
          />
          <label for="isVisible" class="text-sm font-semibold text-gray-700">
            Visible publiquement dans l'application client
          </label>
        </div>
      </div>

      <button class="hidden"></button>
    </form>

    <!-- Actions -->
    <div class="flex gap-3 !mt-8">
      <button
        type="button"
        @click="$emit('cancel')"
        class="flex-1 rounded-lg border border-gray-300 bg-white px-6 py-3 text-sm font-medium text-gray-700 hover:bg-gray-50"
      >
        Annuler
      </button>
      <button
        type="button"
        @click="startSave"
        class="flex-1 rounded-lg bg-primary px-6 py-3 text-sm font-medium text-white hover:bg-primary/90"
      >
        {{ couponData?.mode === 'edit' ? 'Mettre à jour' : 'Créer' }} le coupon
      </button>
    </div>

    <!-- ActionTrigger -->
    <ActionTrigger
      dataKey="saveCoupon"
      ref="saveCouponTrigger"
      @success="onSuccess"
      @failed="onError"
    />
  </div>
</template>

<script setup>
import { reactive, ref, watch, computed } from 'vue'
import ActionTrigger from '@/features/data/presentation/components/ActionTrigger.vue'
import Events from '@/events/events'
import { EVENTS } from '@/shared/constants/commons'

const props = defineProps({
  couponData: { type: Object, default: () => ({}) },
  availableRestaurants: { type: Array, default: () => [] },
})

const emit = defineEmits(['saved', 'cancel'])

const saveCouponTrigger = ref(null)
const form = ref(null)

// Utiliser les restaurants passés en prop ou un tableau vide
const restaurants = computed(() => props.availableRestaurants || [])

const coupon = reactive({
  id: null,
  code: '',
  title: '',
  description: '',
  discount: 0,
  type: 'percentage',
  startDate: null,
  endDate: null,
  storeId: 'all',
  nbAppliance: 1,
  userLimit: 1,
  isVisible: true,
  merchandSupportDiscount: false,
})

// Convert ISO to datetime-local format
const startDateLocal = computed({
  get() {
    if (!coupon.startDate) return ''
    const date = new Date(coupon.startDate)
    date.setMinutes(date.getMinutes() - date.getTimezoneOffset())
    return date.toISOString().slice(0, 16)
  },
  set(value) {
    if (value) {
      const date = new Date(value)
      coupon.startDate = date.toISOString()
    }
  },
})

const endDateLocal = computed({
  get() {
    if (!coupon.endDate) return ''
    const date = new Date(coupon.endDate)
    date.setMinutes(date.getMinutes() - date.getTimezoneOffset())
    return date.toISOString().slice(0, 16)
  },
  set(value) {
    if (value) {
      const date = new Date(value)
      coupon.endDate = date.toISOString()
    }
  },
})

watch(
  () => props.couponData,
  val => {
    if (val && Object.keys(val).length && val.mode !== 'create') {
      Object.assign(coupon, {
        id: val.id || null,
        code: val.code || '',
        // title: val.title || '',
        description: val.description || '',
        discount: val.discount || 0,
        type: val.type || 'percentage',
        startDate: val.startDate || null,
        endDate: val.endDate || null,
        storeId: val.storeId || 'all',
        nbAppliance: val.nbAppliance || val.usageLimit || 0,
        userLimit: val.userLimit || 1,
        isVisible: val.isVisible !== undefined ? val.isVisible : true,
        merchandSupportDiscount: val.merchandSupportDiscount || false,
      })
    }
  },
  { immediate: true },
)

function startSave() {
  const isValid = form.value.checkValidity()
  if (!isValid) {
    form.value.reportValidity()
    return
  }

  // Validate dates
  if (new Date(coupon.endDate) <= new Date(coupon.startDate)) {
    Events.dispatch(EVENTS.TOAST_NOTIFICATION_REQUESTED, {
      title: 'Erreur',
      body: 'La date de fin doit être après la date de début',
    })
    return
  }

  saveCoupon()
}

function saveCoupon() {
  saveCouponTrigger.value.trigger({
    action: props.couponData?.mode === 'edit' ? 'update' : 'create',
    coupon: { ...coupon },
  })
}

function onSuccess() {
  emit('saved')
}

function onError(err) {
  Events.dispatch(EVENTS.TOAST_NOTIFICATION_REQUESTED, {
    title: "Erreur d'enregistrement",
    body: err.result?.message || 'Erreur inconnue',
  })
}
</script>
